import React from 'react';
import { Navigation } from './components/Navigation';
import { HeroSection } from './components/HeroSection';
import { Item1Section } from './components/Item1Section';
import { Item2Section } from './components/Item2Section';
import { Item3Section } from './components/Item3Section';
import { Item5Section } from './components/Item5Section';
import { Item6Section } from './components/Item6Section';
import { BridgeSection } from './components/BridgeSection';
import { ClosingStatement } from './components/ClosingStatement';
import { ProductIntroduction } from './components/ProductIntroduction';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="font-sans text-brand-navy antialiased selection:bg-brand-teal/20" data-id="element-0">
      <Navigation data-id="element-1" />

      <main data-id="element-2">
        <HeroSection data-id="element-3" />

        <Item1Section data-id="element-4" />
        <Item2Section data-id="element-5" />
        <Item3Section data-id="element-6" />
        <Item5Section data-id="element-7" />
        <Item6Section data-id="element-8" />

        <BridgeSection data-id="element-9" />
        <ClosingStatement data-id="element-10" />
        <ProductIntroduction data-id="element-11" />
        <FinalCTA data-id="element-12" />
      </main>

      <Footer data-id="element-13" />
    </div>;
}